/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_SplitInputs */

const en_us2_profile_row_split = /** @type {(inputs: Profile_Row_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week split`)
};

const pt_br2_profile_row_split = /** @type {(inputs: Profile_Row_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisão da semana`)
};

const es_419_profile_row_split = /** @type {(inputs: Profile_Row_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`División de la semana`)
};

const pt_pt2_profile_row_split = /** @type {(inputs: Profile_Row_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisão da semana`)
};

const fr_fr2_profile_row_split = /** @type {(inputs: Profile_Row_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répartition de la semaine`)
};

const de_de2_profile_row_split = /** @type {(inputs: Profile_Row_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochenaufteilung`)
};

const it_it2_profile_row_split = /** @type {(inputs: Profile_Row_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suddivisione della settimana`)
};

/**
* | output |
* | --- |
* | "Week split" |
*
* @param {Profile_Row_SplitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_split = /** @type {((inputs?: Profile_Row_SplitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_SplitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_split(inputs)
	if (locale === "es-419") return es_419_profile_row_split(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_split(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_split(inputs)
	if (locale === "de-DE") return de_de2_profile_row_split(inputs)
	if (locale === "it-IT") return it_it2_profile_row_split(inputs)
	return en_us2_profile_row_split(inputs)
});
export { profile_row_split as "profile.row_split" }